export default __webpack_public_path__ + "static/media/my247.dbf18fe7.PNG";